export const labtestConstant = {
    GO_TO_LABTEST: 'LABTEST_GO_TO_LABTEST',
    GET_LAB_TEST_SUCCESS: 'LABTEST_GET_LAB_TEST_SUCCESS',
    SET_OPEN_LAB_TEST: 'LABTEST_SET_OPEN_LAB_TEST',
};

